import { BouncingLoader } from "./styles"

export const DotsLoader = (props) => {
    return (
        <BouncingLoader blue={props.blue}>
            <div></div>
            <div></div>
            <div></div>
        </BouncingLoader>
    )
}